interface Props {
  disabled?: boolean;
}
const SvgPlus: React.FC<Props> = ({ disabled = false }) => {
  return (
    <svg
      style={{ cursor: disabled ? "not-allowed" : "pointer" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_21327_18566)">
        <path
          d="M5.98827 1.18905C5.77624 1.19216 5.57411 1.27932 5.4263 1.43137C5.27849 1.58343 5.19709 1.78795 5.19999 1.99999V5.19999H1.99999C1.89398 5.19849 1.78873 5.21807 1.69036 5.25761C1.59198 5.29714 1.50245 5.35582 1.42695 5.43026C1.35146 5.5047 1.29151 5.59339 1.25059 5.6912C1.20967 5.78901 1.1886 5.89397 1.1886 5.99999C1.1886 6.10601 1.20967 6.21097 1.25059 6.30878C1.29151 6.40658 1.35146 6.49528 1.42695 6.56972C1.50245 6.64415 1.59198 6.70284 1.69036 6.74237C1.78873 6.7819 1.89398 6.80149 1.99999 6.79999H5.19999V9.99999C5.19849 10.106 5.21808 10.2112 5.25761 10.3096C5.29714 10.408 5.35583 10.4975 5.43026 10.573C5.5047 10.6485 5.5934 10.7085 5.6912 10.7494C5.78901 10.7903 5.89397 10.8114 5.99999 10.8114C6.10601 10.8114 6.21098 10.7903 6.30878 10.7494C6.40659 10.7085 6.49529 10.6485 6.56972 10.573C6.64416 10.4975 6.70285 10.408 6.74238 10.3096C6.78191 10.2112 6.80149 10.106 6.79999 9.99999V6.79999H9.99999C10.106 6.80149 10.2113 6.7819 10.3096 6.74237C10.408 6.70284 10.4975 6.64415 10.573 6.56972C10.6485 6.49528 10.7085 6.40658 10.7494 6.30878C10.7903 6.21097 10.8114 6.10601 10.8114 5.99999C10.8114 5.89397 10.7903 5.78901 10.7494 5.6912C10.7085 5.59339 10.6485 5.5047 10.573 5.43026C10.4975 5.35582 10.408 5.29714 10.3096 5.25761C10.2113 5.21807 10.106 5.19849 9.99999 5.19999H6.79999V1.99999C6.80146 1.89302 6.78145 1.78685 6.74117 1.68775C6.70088 1.58865 6.64114 1.49864 6.56546 1.42303C6.48978 1.34742 6.39971 1.28776 6.30057 1.24757C6.20143 1.20738 6.09524 1.18748 5.98827 1.18905Z"
          className={`${disabled ? "fill-gray3" : "fill-current"}`}
        />
      </g>
      <defs>
        <clipPath id="clip0_21327_18566">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgPlus;
